<template>
  <div class="controls container" controlsBg="">

    <div v-if="customControls" class="controls__select">
      <slot name="custom-controls-top" />
    </div>

    <div v-else>
      <div v-if="$mq === 'breakpoint'"
        class="controls__trigger"
      >
        <btn-pill
          @click.native="toggleSlideDown()"
          :controlsBg="controlsBg"
          :class="{pressed: active}"
          :btnText="$t('filter.filterModeTitleMobile')" btn-size="xs" btn-type="secondary" btn-inverse
        >
          <font-awesome-icon :icon="calendar" />
        </btn-pill>
      </div>
      <slide-up-down :class="{forceOverflow: slideDownOverflow}" v-if="$mq === 'breakpoint'"
        :active="active"
        class="controls__data mobile"
      >
        <div class="controls__select-mobile note" v-if="hasFilterRight || hasFilterLeft">
          <label class="label">{{ filterModeTitle }}</label>
          <v-select v-model="selectedFormat" :onChange="changeFormat" :searchable="false" :options="selectOptions"></v-select>
        </div>
        <div class="controls__filters-mobile note" @click="slideDownOverflow = true">
          <controls-filter v-if="hasFilterLeft" :filterTitle="filterTitleLeft" :formatDate="calendarFormat" :startDate="filterStartDateLeft" :dateId="filterDateIdLeft" :disabledDate="disabledDate"></controls-filter>
          <controls-filter v-if="hasFilterRight" :filterTitle="filterTitleRight" :formatDate="calendarFormat" :startDate="filterStartDateRight" :dateId="filterDateIdRight" :disabledDate="disabledDate"></controls-filter>
        </div>
      </slide-up-down>
      <div v-else class="controls__data">
        <div class="controls__select note" v-if="hasFilterRight || hasFilterLeft">
          <label class="label">{{ filterModeTitle }}</label>
          <v-select v-model="selectedFormat" :onChange="changeFormat" :searchable="false" :options="selectOptions"></v-select>
        </div>
        <div class="controls__filters note">
          <controls-filter v-if="hasFilterLeft" :filterTitle="filterTitleLeft" :formatDate="calendarFormat" :startDate="filterStartDateLeft" :dateId="filterDateIdLeft" :disabledDate="disabledDate"></controls-filter>
          <controls-filter v-if="hasFilterRight" :filterTitle="filterTitleRight" :formatDate="calendarFormat" :startDate="filterStartDateRight" :dateId="filterDateIdRight" :disabledDate="disabledDate"></controls-filter>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {eventBus} from '@/main';
import ControlsFilter from '@/components/shared/controlsbar/ControlsFilter';
import ControlsDate from '@/components/shared/controlsbar/ControlsDate';
import BtnPill from '../shared/buttons/BtnPill';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import faCalendar from '@fortawesome/fontawesome-free-solid/faCalendarAlt';
import SlideUpDown from 'vue-slide-up-down';
import vSelect from 'vue-select';

export default {
  components: {
    ControlsFilter,
    ControlsDate,
    BtnPill,
    FontAwesomeIcon,
    faAngleDown,
    SlideUpDown,
    vSelect
  },
  props: {
    controlsBg: {
      type: String
    },
    customControls: {
      type: Boolean,
      default: false
    },
    hasFilterLeft: {
      type: Boolean,
      default: false
    },
    hasFilterRight: {
      type: Boolean,
      default: false
    },
    filterDateIdLeft: {
      type: String
    },
    filterDateIdRight: {
      type: String
    },
    filterStartDateLeft: {
      type: String
    },
    filterStartDateRight: {
      type: String
    },
    filterTitleLeft: {
      type: String
    },
    filterTitleRight: {
      type: String
    },
    filterModeSelected: {
      type: String
    },
    filterModeTitle: {
      type: String
    },
    disabledDate: {
      type: Function,
      default: () => {
        return false;
      }
    }
  },
  computed: {
    calendar () {
      return faCalendar;
    },
    angleDown () {
      return faAngleDown;
    },
    selectOptions () {
      return [
        {
          label: this.$t('filter.yearly'),
          value: 'YYYY'
        },
        {
          label: this.$t('filter.monthly'),
          value: 'MMMM YYYY',
          selected: true
        }
      ];
    },
    selectedFormat () {
      return this.filterModeSelected === 'year' ? this.$t('filter.yearly') : this.$t('filter.monthly');
    }
  },
  methods: {
    changeFormat (e) {
      // Hacky
      e = this.modifyChangeFormatEventIfNeccessaryHack(e);

      this.calendarFormat = e.value;
      eventBus.$emit(
        'filterMode',
        this.calendarFormat === 'YYYY' ? 'year' : 'month'
      );
    },
    modifyChangeFormatEventIfNeccessaryHack (e) {
      // WARNING!
      // Hack to prevent the first selection bug of vue-select
      const label = e;
      if (e.value === undefined) {
        /*
         * Expected event is, for exmaple:
         * <code>
         * {
         *   label: Anual,
         *   value: YYYY
         * }
         * </code>
         *
         * But the first time the event is the label:
         * <code>
         * Anual
         * </code>
         *
         * So, we have to create the event
         */
        const value = e === this.$t('filter.yearly') ? 'YYYY' : 'MMMM YYYY';
        e = {
          label: label,
          value: value
        };
      }
      return e;
    },
    toggleSlideDown () {
      this.active = !this.active;
      this.slideDownOverflow = false;
    }
  },
  data () {
    return {
      active: false,
      calendarFormat: 'YYYY',
      slideDownOverflow: false
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../stylesheets/variables.scss";
.label {
  margin-right: $sp-margin-smaller;
  @media (max-width: $screen-l-max) {
    display: block;
    margin-bottom: $sp-margin-smaller;
  }
}
.controls {
  @if (lightness($primary-light1) > 30%) {
    background-color: darken($primary-light1, 10);
  } @else {
    background-color: $primary-light1;
  }
  color: $bodycolor-inverse;
  position: relative;
  @media (min-width: $breakpoint) {
    height: $topbarHeight;
    display: flex;
    align-items: center;
  }

  &__trigger {
    height: $controlsHeight-s;
    display: flex;
    align-items: center;
    button:focus {
      outline: 0;
    }
  }
  &__data {
    @media (max-width: $breakpoint) {
      position: absolute;
      left: 0;
      right: 0;
      z-index: 1;
      background-color: $primary-light1;
      padding: 0 $sp-margin;
    }
    @media (min-width: $breakpoint) {
      flex-grow: 1;
      display: flex;
      align-items: center;
    }
  }

  [controlsBg="light"] & {
    background-color: $black-light9;
    color: $bodycolor;
    &__data {
      background-color: $black-light9;
      color: $bodycolor;
    }
  }
  &__select,
  &__filters {
    color: $white-trans4;
    display: flex;
    align-items: center;
    border-bottom: 0;
    border-left: 1px solid $white-trans6;
    margin-right: 0;
    padding-top: 0;
    padding-bottom: 0;
    > div {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    [controlsBg="light"] & {
      color: $black-trans4;
      border-color: $black-trans6;
    }

    &:first-of-type {
      border-left: 0;
      padding-left: 0;
    }
  }

  &__filters {
    > div {
      padding-left: $sp-margin-small;
    }
  }
  &__select-mobile {
    margin-top: $sp-margin-small;
    margin-bottom: $sp-margin-small;
  }
  &__filters-mobile {
    @media (min-width: $screen-s) {
      display: flex;
      justify-content: space-between;
      color: $white-trans4;
      [controlsBg="light"] & {
        color: $black-trans4;
      }
    }
    > div {
      margin-bottom: $sp-margin-small;
      @media (min-width: $screen-s) {
        width: 46%;
      }
    }
  }
  &__date-mobile {
    border-top: 1px solid $white-trans6;
    margin-top: $sp-margin-small;
    padding-bottom: $sp-margin-small;
    [controlsBg="light"] & {
      border-top: 1px solid $black-trans6;
    }
  }
}

.forceOverflow {
  overflow: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ControlsBar.vue